import _jsx from"@babel/runtime/helpers/esm/jsx";import _defineProperty from"@babel/runtime/helpers/esm/defineProperty";import"core-js/modules/web.dom-collections.iterator.js";import React from'react';// import classNames from 'classnames';
// import Icon from 'soapbox/components/icon';
import SubNavigation from'soapbox/components/sub_navigation';export default class ColumnHeader extends React.PureComponent{constructor(){super(...arguments);_defineProperty(this,"handleClick",()=>{this.props.onClick();});}render(){const{type}=this.props;return/*#__PURE__*/_jsx(SubNavigation,{message:type});}// render() {
//   const { icon, type, active, columnHeaderId } = this.props;
//
//   return (
//     <h1 className={classNames('column-header', { active })} id={columnHeaderId || null}>
//       <button onClick={this.handleClick}>
//         {icon && <Icon id={icon} fixedWidth className='column-header__icon' />}
//         {type}
//       </button>
//     </h1>
//   );
// }
}